import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const STATUS_ENDPOINT = (complaintTypeId) =>
  `/api/v1/complaint-types/${complaintTypeId}/statuses`;

export const COMPLAINT_SUMMARY_ENDPOINT = '/api/v1/complaints/summary';

const rejectRequest = (error, thunkApi) => {
  const data = error?.response?.data;
  const details = Array.isArray(data?.errors)
    ? data.errors.map((item) => item?.message).filter(Boolean)
    : [];

  return thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message:
      (details.length ? details.join(' ') : null) ??
      data?.message ??
      data?.error ??
      error?.message ??
      'Something went wrong',
  });
};

export const fetchStatuses = createAsyncThunk(
  'status/fetchStatuses',
  async (complaintTypeId, thunkApi) => {
    try {
      const response = await api.get(STATUS_ENDPOINT(complaintTypeId), {
        signal: thunkApi.signal,
      });
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);

export const fetchComplaintSummary = createAsyncThunk(
  'status/fetchComplaintSummary',
  async (complaintTypeId, thunkApi) => {
    try {
      const response = await api.get(COMPLAINT_SUMMARY_ENDPOINT, {
        params: { complaintTypeId },
        signal: thunkApi.signal,
      });
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);
